import { Injectable } from '@angular/core';
import {AuthService} from "./auth.service";
import {
  Partecipant
} from "../../classes/common/partecipant";
import {Poi} from "../../classes/common/poi";

@Injectable({
  providedIn: 'root'
})
export class GestoreImmaginiService {

  constructor() { }

  static extractPathFromUrl(url: string): string {
    const match = url.match(/\/o\/(.*?)\?/);
    if (!match || !match[1]) throw new Error('Path non trovato');
    return decodeURIComponent(match[1]); // decodifica %2F in /
  }

  static async uploadFileMarker(file: Blob, target: Partecipant | Poi) {
    const storageRef = AuthService.firebase.storage().ref();
    const fileRef = storageRef.child(`markers/${target.idOrganization}/${target._id}`);

    const snapshot: any = await fileRef.put(file);
    return await snapshot.ref.getDownloadURL();
  }

  static deleteFileFromPath(path: string): void {
    const storageRef = AuthService.firebase.storage().ref();
    const fileRef = storageRef.child(path);

    fileRef.delete().then(() => {
      console.log('File eliminato con successo:', path);
    }).catch((error: any) => {
      console.error('Errore durante l\'eliminazione:', error);
    });
  }
}
